// src/pages/Auth/Register.jsx

import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { auth, db } from '../../firebase';
import toast from 'react-hot-toast';

function Register() {
  const [companyName, setCompanyName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');

    if (!companyName || !email || !password) {
      setError('Lütfen tüm alanları doldurun.');
      return;
    }

    setLoading(true);
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      const companyDocRef = doc(db, 'companies', user.uid);
      await setDoc(companyDocRef, {
        companyName: companyName,
        ownerUID: user.uid,
        createdAt: new Date(),
      });

      const userDocRef = doc(db, 'users', user.uid);
      await setDoc(userDocRef, {
        email: user.email,
        companyId: user.uid,
        role: 'admin',
      });
      
      toast.success('Şirketiniz başarıyla oluşturuldu! Şimdi giriş yapabilirsiniz.');
      navigate('/login');

    } catch (err) {
      if (err.code === 'auth/email-already-in-use') {
        setError('Bu e-posta adresi zaten kullanılıyor.');
      } else {
        setError('Kayıt sırasında bir hata oluştu. Lütfen tekrar deneyin.');
      }
      console.error(err);
    }
    setLoading(false);
  };

  return (
        <div className="auth-page" style={page}>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
                @keyframes spin { to { transform: rotate(360deg); } }
                
                body { margin: 0; padding: 0; }
                
                .login-input:focus { border-color: #06C167 !important; box-shadow: 0 0 0 3px rgba(22,163,74,0.1) !important; }
                .login-btn:hover { background: #06C167 !important; }

                /* Mobil Uyumluluk */
                @media (max-width: 768px) {
                    .auth-page { flex-direction: column !important; min-height: 100vh !important; }
                    .left-panel { flex: none !important; padding: 40px 24px !important; text-align: center !important; align-items: center !important; }
                    .left-title { font-size: 28px !important; margin-bottom: 8px !important; }
                    .left-sub { font-size: 14px !important; margin-bottom: 16px !important; }
                    .feature-list { display: none !important; }
                    .left-footer { position: relative !important; bottom: auto !important; left: auto !important; margin-top: 16px !important; text-align: center; }
                    
                    .right-panel { padding: 30px 20px !important; align-items: flex-start !important; }
                    .form-container { max-width: 100% !important; }
                }
            `}</style>

            {/* Left — Branding Panel */}
            <div className="left-panel" style={leftPanel}>
                <div style={leftContent}>
                    <div style={logoBadge}>
                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/>
                        </svg>
                    </div>
                    <h1 className="left-title" style={leftTitle}>On Muhasebe</h1>
                    <p className="left-sub" style={leftSub}>Sipariş, stok, fatura ve müşteri yönetimini tek platformda birleştirin.</p>

                    <div className="feature-list" style={featureList}>
                        {['Gerçek zamanlı stok takibi', 'Otomatik fatura oluşturma', 'Müşteri mutabakat raporları', 'Pazaryeri entegrasyonu'].map((f, i) => (
                            <div key={i} style={featureItem}>
                                <span style={checkIcon}>✓</span>
                                <span>{f}</span>
                            </div>
                        ))}
                    </div>
                </div>
                <p className="left-footer" style={leftFooter}>© 2026 On Muhasebe</p>
            </div>

            {/* Right — Form Panel */}
            <div className="right-panel" style={rightPanel}>
                <div className="form-container" style={formContainer}>
                    <h2 style={formTitle}>
                        Yeni Şirket Kaydı
                    </h2>
                    <p style={formSub}>
                        İşletmenizi dijitalleştirmeye hemen başlayın.
                    </p>

                    <form onSubmit={handleRegister}>
                        <div style={fieldGroup}>
                            <label style={label}>Şirket Adı</label>
                            <input className="login-input" style={input} type="text"
                                value={companyName} onChange={e => setCompanyName(e.target.value)}
                                placeholder="Şirketiniz" required />
                        </div>

                        <div style={fieldGroup}>
                            <label style={label}>Yönetici E-posta</label>
                            <input className="login-input" style={input} type="email"
                                value={email} onChange={e => setEmail(e.target.value)}
                                placeholder="ornek@firma.com" required />
                        </div>

                        <div style={fieldGroup}>
                            <label style={label}>Şifre</label>
                            <div style={{ position: 'relative' }}>
                                <input className="login-input" style={input}
                                    type={showPassword ? 'text' : 'password'}
                                    value={password} onChange={e => setPassword(e.target.value)}
                                    placeholder="••••••••" required />
                                <button type="button" onClick={() => setShowPassword(!showPassword)} style={eyeBtn}>
                                    {showPassword ? '🙈' : '👁️'}
                                </button>
                            </div>
                        </div>

                        {error && <div style={errBox}>{error}</div>}

                        <button className="login-btn" type="submit" disabled={loading}
                            style={{ ...greenBtn, opacity: loading ? 0.7 : 1 }}>
                            {loading ? <><span style={spinner}/> Kayıt yapılıyor...</> : 'Ücretsiz Kayıt Ol'}
                        </button>

                        <p style={footerText}>
                            Zaten bir hesabınız var mı?{' '}
                            <Link to="/login" style={greenLink}>Giriş Yapın</Link>
                        </p>
                    </form>
                </div>
            </div>
        </div>
  );
}

// ---- Uber-inspired white + green styles (Copied from Login) ----
const page = {
    display: 'flex', minHeight: '100vh', fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif'
};

const leftPanel = {
    flex: '0 0 42%', background: 'linear-gradient(160deg, #166534, #06C167 40%, #06C167)',
    display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '60px 48px',
    position: 'relative', overflow: 'hidden'
};

const leftContent = { position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column' };

const logoBadge = {
    width: '56px', height: '56px', borderRadius: '14px',
    background: 'rgba(255,255,255,0.15)', backdropFilter: 'blur(8px)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '28px'
};

const leftTitle = {
    fontSize: '36px', fontWeight: '800', color: 'white', margin: '0 0 12px', letterSpacing: '-1px'
};

const leftSub = {
    fontSize: '16px', color: 'rgba(255,255,255,0.8)', lineHeight: '1.6', margin: '0 0 36px', maxWidth: '340px'
};

const featureList = { display: 'flex', flexDirection: 'column', gap: '14px' };

const featureItem = {
    display: 'flex', alignItems: 'center', gap: '12px', color: 'rgba(255,255,255,0.9)', fontSize: '14px', fontWeight: '500'
};

const checkIcon = {
    width: '22px', height: '22px', borderRadius: '50%',
    background: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: '12px', color: 'white', fontWeight: '700', flexShrink: 0
};

const leftFooter = {
    position: 'absolute', bottom: '32px', left: '48px', color: 'rgba(255,255,255,0.4)', fontSize: '12px'
};

const rightPanel = {
    flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: '#ffffff', padding: '40px'
};

const formContainer = { width: '100%', maxWidth: '380px' };

const formTitle = {
    fontSize: '28px', fontWeight: '700', color: '#111827', margin: '0 0 4px', letterSpacing: '-0.5px'
};

const formSub = { fontSize: '14px', color: '#6b7280', margin: '0 0 28px' };

const fieldGroup = { marginBottom: '20px' };

const label = {
    display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: '600', color: '#374151'
};

const input = {
    width: '100%', padding: '13px 14px', fontSize: '14px', fontFamily: 'inherit',
    border: '1.5px solid #e5e7eb', borderRadius: '10px', boxSizing: 'border-box',
    outline: 'none', transition: 'all 0.2s', background: '#fafafa', color: '#111827'
};

const eyeBtn = {
    position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)',
    background: 'none', border: 'none', cursor: 'pointer', fontSize: '14px', padding: '4px'
};

const greenBtn = {
    width: '100%', padding: '14px', border: 'none', borderRadius: '10px',
    background: '#06C167', color: 'white', fontSize: '15px', fontWeight: '700',
    cursor: 'pointer', transition: 'all 0.2s', fontFamily: 'inherit',
    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px'
};

const errBox = {
    padding: '10px 14px', borderRadius: '8px', marginBottom: '16px',
    background: '#fef2f2', border: '1px solid #fecaca', color: '#dc2626', fontSize: '13px', textAlign: 'center'
};

const footerText = { textAlign: 'center', marginTop: '20px', color: '#9ca3af', fontSize: '13px' };

const greenLink = { color: '#06C167', textDecoration: 'none', fontWeight: '600' };

const spinner = {
    display: 'inline-block', width: '16px', height: '16px',
    border: '2px solid rgba(255,255,255,0.3)', borderTopColor: 'white',
    borderRadius: '50%', animation: 'spin 0.6s linear infinite'
};

export default Register;
